import React from 'react';


import styled from 'styled-components';
import MainJoinButton from "../../CustomerActions/ContactButton";

const Section = styled.section`
    color: #141414;
    margin: 30vh 3% 0 3%;
    //position: absolute;
    //top: 35%;
    flex: 1;
    font-size: 1.8vw;
    //@media (max-width: 1000px) {
    //    top: 55%;
    //    font-size: 1.9vw;
    //}
    @media (max-width: 800px) {
        font-size: 5.2vw;
        margin-top: 17%;
        //text-align: center;
    }
`;

const Title = styled.h1`
    font-size: 3em;
    margin: 0 0 0.2em;
    font-weight: 900;
`;

const Subtitle = styled.p`
    margin: 0 0 0.5em;
    font-weight: 300;
`;



const pitch = () => {
    return (
      <Section>
        <Title>Hi, I create software.</Title>
        <Subtitle>Welcome to v0.2.x of my website.</Subtitle>
          {/*<MainJoinButton>Connect with me online</MainJoinButton>*/}
      </Section>
    )
};

export default pitch;


// WEBPACK FOOTER //
// ./src/components/Masthead/Pitch/Pitch.jsx